<ds-metadata-field-wrapper [label]="label | translate">
    <div *ngVar="(originals$ | async)?.payload as originals">
        <div *ngIf="hasValuesInBundle(originals)">
            <h3 class="h5 simple-view-element-header">{{"item.page.filesection.original.bundle" | translate}}</h3>
            <ds-pagination *ngIf="originals?.page?.length > 0"
                           [hideGear]="true"
                           [hidePagerWhenSinglePage]="true"
                           [paginationOptions]="originalOptions"
                           [collectionSize]="originals?.totalElements"
                           [retainScrollPosition]="true">


                <div class="file-section row mb-3" *ngFor="let file of originals?.page;" [ngClass]="getFileTypeClass(file)" [title]="getHoverHint(file)">
                    <div class="col-3">
                        <file-type-thumbnail [file]="file"></file-type-thumbnail>
                    </div>
                    <div class="col-7">
                        <dl class="row">
                            <dt class="col-md-4">{{"item.page.filesection.name" | translate}}</dt>
                            <dd class="col-md-8">{{ dsoNameService.getName(file) }}</dd>

                            <dt class="col-md-4">{{"item.page.filesection.size" | translate}}</dt>
                            <dd class="col-md-8">{{(file.sizeBytes) | dsFileSize }}</dd>


                            <dt class="col-md-4">{{"item.page.filesection.format" | translate}}</dt>
                            <dd class="col-md-8">{{(file.format | async)?.payload?.description}}</dd>

                          <ng-container *ngIf="file.hasMetadata('dc.description')">
                            <dt class="col-md-4">{{"item.page.filesection.description" | translate}}</dt>
                            <dd class="col-md-8">{{file.firstMetadataValue("dc.description")}}</dd>
                          </ng-container>
                        </dl>
                    </div>
                    <div class="col-2">
                        <ds-themed-file-download-link [bitstream]="file" [item]="item">
                            {{"item.page.filesection.download" | translate}}
                        </ds-themed-file-download-link>
                    </div>
                </div>
            </ds-pagination>
        </div>
    </div>
    <div *ngVar="(licenses$ | async)?.payload as licenses">
        <div *ngIf="hasValuesInBundle(licenses)">
            <h3 class="h5 simple-view-element-header">{{"item.page.filesection.license.bundle" | translate}}</h3>
            <ds-pagination *ngIf="licenses?.page?.length > 0"
                           [hideGear]="true"
                           [hidePagerWhenSinglePage]="true"
                           [paginationOptions]="licenseOptions"
                           [collectionSize]="licenses?.totalElements"
                           [retainScrollPosition]="true">


                <div class="file-section row" *ngFor="let file of licenses?.page;">
                    <div class="col-3">
                        <ds-themed-thumbnail [thumbnail]="(file.thumbnail | async)?.payload"></ds-themed-thumbnail>
                    </div>
                    <div class="col-7">
                        <dl class="row">
                            <dt class="col-md-4">{{"item.page.filesection.name" | translate}}</dt>
                            <dd class="col-md-8">{{ dsoNameService.getName(file) }}</dd>

                            <dt class="col-md-4">{{"item.page.filesection.size" | translate}}</dt>
                            <dd class="col-md-8">{{(file.sizeBytes) | dsFileSize }}</dd>

                            <dt class="col-md-4">{{"item.page.filesection.format" | translate}}</dt>
                            <dd class="col-md-8">{{(file.format | async)?.payload?.description}}</dd>


                            <dt class="col-md-4">{{"item.page.filesection.description" | translate}}</dt>
                            <dd class="col-md-8">{{file.firstMetadataValue("dc.description")}}</dd>
                        </dl>
                    </div>
                    <div class="col-2">
                        <ds-themed-file-download-link [bitstream]="file" [item]="item">
                            {{"item.page.filesection.download" | translate}}
                        </ds-themed-file-download-link>
                    </div>
                </div>
            </ds-pagination>
        </div>
    </div>
</ds-metadata-field-wrapper>
